export function triggerDownload(assetUrl: string | null, filename: string): void {
  if (assetUrl === null) {
    return;
  }

  const a = document.createElement('a');
  a.setAttribute('download', filename);
  a.setAttribute('href', assetUrl);
  a.setAttribute('target', '_blank');

  const event = new MouseEvent('click', {
    view: window,
    bubbles: false,
    cancelable: true,
  });

  a.dispatchEvent(event);
}
